import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FileSignature } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { EsignTracker } from './EsignTracker';
import { esignAPI, ESIGN_LABELS } from '../../lib/esignAPI';

// Onboarding checklist: next steps after submit (Engagement Letter -> Electronic Signature -> Completed); resumes at signing.
export const EsignOnboardingCard = () => {
  const [lt, setLt] = useState(undefined);
  useEffect(() => { esignAPI.my().then((r) => setLt(r.letter)).catch(() => setLt(null)); }, []);
  if (lt === undefined) return null;
  const st = lt?.esign_status || 'letter_generating';
  const cta = lt && ['ready_for_review', 'awaiting_signature', 'partially_signed', 'error'].includes(st) && lt.my_status !== 'SIGNED';
  return (
    <Card data-testid="esign-onboarding-card">
      <CardContent className="space-y-3 pt-6">
        <EsignTracker status={lt ? st : 'form_completed'} />
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm" data-testid="esign-onboarding-status">
            Engagement letter: <b>{lt ? ESIGN_LABELS[st] : 'Being prepared'}</b>
            {!lt && <span className="text-muted-foreground"> – we&apos;ll notify you when it&apos;s ready to sign.</span>}
          </p>
          {cta && <Button asChild data-testid="esign-onboarding-continue"><Link to="/onboarding/engagement"><FileSignature className="mr-2 h-4 w-4" />{st === 'ready_for_review' ? 'Review engagement letter' : 'Continue to signing'}</Link></Button>}
          {lt && ['signed', 'onboarding_completed'].includes(st) && <Button variant="outline" asChild><Link to="/onboarding/engagement">View signed letter</Link></Button>}
        </div>
      </CardContent>
    </Card>
  );
};
